var _rect, _rect2, _rect3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.7,
    y: 6.5335,
    width: 14.6,
    height: 13.7111,
    stroke: "#393734",
    strokeWidth: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4.5,
    width: 1.5,
    height: 4,
    fill: "#393734"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 4.5,
    width: 1.5,
    height: 4,
    fill: "#393734"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.00485,
    y1: 12.1892,
    x2: 20.0047,
    y2: 12.3,
    stroke: "#393734",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.639961bcc02450b0224f281d413da120.svg";
export { ForwardRef as ReactComponent };